import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/gameIntro.css";
import useTranslation from "../hooks/useTranslation";

function GameIntro({ updateProgress }) {
  const navigate = useNavigate();
  const { t, language } = useTranslation();

  // Mapeo de idiomas a sus URLs y códigos de país
  const moduleLinks = {
    en: { url: "https://greenscape-project.eu/ed-ma/#", code: "EN" },
    es: { url: "https://greenscape-project.eu/es/ed-ma/", code: "ES" },
    el: { url: "https://greenscape-project.eu/el/ed-ma/", code: "EL" },
    bg: { url: "https://greenscape-project.eu/bg/ed-ma/", code: "BG" },
    fi: { url: "https://greenscape-project.eu/fi/ed-ma/", code: "FI" },
    cs: { url: "https://greenscape-project.eu/cs/ed-ma/", code: "CS" }
  };

  // Obtener el enlace correspondiente al idioma actual
  const currentModuleLink = moduleLinks[language] || moduleLinks.en;

  const handleContinue = () => {
    updateProgress('intro');
    navigate('/character-selection');
  };
  return (
    <div className="game-intro-container">
      {/* Sección izquierda con información */}
      <div className="intro-info-section">
        <div className="intro-title">
          <h1>{t('gameIntro.title')}</h1>
          <h2>{t('gameIntro.subtitle')}
          </h2>
        </div>

        <div className="intro-description">
          <p>
          {t('gameIntro.description')}
          </p>
        </div>

        {/* Enlace al módulo según el idioma seleccionado */}
        <div className="modules-links">
          <a 
            href={currentModuleLink.url} 
            target="_blank" 
            rel="noreferrer"
            className="module-link"
          >
            <span className="module-code">{currentModuleLink.code}</span>
            <span className="module-arrow">↗</span>
          </a>
        </div>

        <button className="continue-button" onClick={handleContinue}>
          {t('gameIntro.continueButton')}
        </button>
      </div>

      {/* Sección derecha con video */}
      <div className="intro-video-section">
        <div className="video-container">
          <iframe 
            className="intro-video"
            src="https://www.youtube.com/embed/4tGOcobZSEc"
            title="Narrative Video"

            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default GameIntro;
